// extracted by mini-css-extract-plugin
var _1 = "InPlaceEditable-module__editable--U3ooU";
export { _1 as "editable" }
